import { CountriesList, USStates } from "./constants";

/** Maps API citizenship (e.g. `"United States"`) to `CountriesList` `value` (e.g. `"US"`). */
export function citizenshipLabelOrCodeToCountryCode(raw) {
  if (raw === undefined || raw === null || raw === "") return undefined;
  const s = String(raw).trim();
  const byValue = CountriesList.find((c) => c.value === s);
  if (byValue) return byValue.value;
  const byLabel = CountriesList.find((c) => c.label.toLowerCase() === s.toLowerCase());
  return byLabel?.value ?? s;
}

/**
 * Maps a country code or name to the full country name (e.g. `"US"` -> `"United States"`).
 * The Stake Checking wizard stores and submits citizenship as the full name, not the code.
 */
export function citizenshipCodeOrLabelToLabel(raw) {
  if (raw === undefined || raw === null || raw === "") return undefined;
  const s = String(raw).trim();
  const byValue = CountriesList.find((c) => c.value.toLowerCase() === s.toLowerCase());
  if (byValue) return byValue.label;
  const byLabel = CountriesList.find((c) => c.label.toLowerCase() === s.toLowerCase());
  return byLabel?.label ?? s;
}

/** Maps API state (e.g. `"New York"`) to `USStates` `value` (e.g. `"NY"`). */
export function usStateLabelOrCodeToTwoLetter(raw) {
  if (raw === undefined || raw === null || raw === "") return undefined;
  const t = String(raw).trim();
  if (/^[a-zA-Z]{2}$/.test(t)) {
    const byValue = USStates.find((s) => s.value.toUpperCase() === t.toUpperCase());
    return byValue?.value ?? t.toUpperCase();
  }
  const byLabel = USStates.find((s) => s.label.toLowerCase() === t.toLowerCase());
  return byLabel?.value ?? t;
}

/** Normalizes flat `/api/sso/prefill` `data` for UIs that expect country/state codes. */
export function normalizeSsoPrefillFlatPayload(ssoPayload) {
  if (!ssoPayload || typeof ssoPayload !== "object") return ssoPayload;
  const next = { ...ssoPayload };
  const c = citizenshipLabelOrCodeToCountryCode(next.citizenship);
  if (c !== undefined) next.citizenship = c;
  const rawState = next["mailingstate"] ?? next.state;
  if (rawState != null && rawState !== "") {
    const code = usStateLabelOrCodeToTwoLetter(rawState);
    if (code != null) {
      next["mailingstate"] = code;
      if (Object.prototype.hasOwnProperty.call(next, "state")) next.state = code;
    }
  }
  return next;
}
